export enum ExceptionType {
  authentication = 1,
  repository = 2,
  product = 3,
  order = 4,
  printer = 5,
  watermark = 6,
}

export enum UserGroup {
  admin = 'admin',
  staff = 'staff',
  customer = 'customer',
}

export enum UserStatus {
  inactive = 'inactive',
  pending = 'pending',
  active = 'active',
}

export enum UserAppearance {
  bright = 'bright',
  dark = 'dark',
  adaptive = 'adaptive',
}

/** Which front-end is opening the session. The API refuses a customer asking for
 *  `backoffice`, so this console always sends it explicitly. */
export type ClientAudience = 'backoffice' | 'platform';

export interface SignInFormControl {
  email: string;
  password: string;
  phone_number?: string;
  userSettings?: UserSettings;
  audience?: ClientAudience;
}

export interface UserData {
  username?: string;
  phoneNumber?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
  dateOfBirth?: string; // ISO date string format: "1989-02-23T00:00:00"
  orderNumber?: number;
  issuedAt?: string; // ISO datetime string format: "2026-02-19T13:48:20.062554Z"
  skipperStatus?: string;
  media?: Array<{
    id: number;
    url: string;
    type?: string;
    mime?: string;
  }>;
}

export interface Media {
  id: string;
  url: string;
  mime: string;
}

export interface UserSettings {
  localization: string;
  appearance: UserAppearance;
}

export interface SignInUserData {
  accountId: string;
  status: UserStatus;
  group: UserGroup;
  passwordChangeRequired?: boolean;
  accessToken: string;
  refreshToken: string;
  userData: UserData;
  userSettings: UserSettings;
  error?: GeneralError;
}

export interface SignUpFormControl extends SignInFormControl {
  source: string;
  organization_id?: string;
  group?: string;
  force_password_change_on_first_login?: boolean;
}

export interface NotificationSubscriptionRequest {
  platform: string;
  isMobile: boolean;
  subscription: PushSubscription;
}

export interface ValidationEmail {
  token: string;
}

export interface ValidationEmailResult {
  status: string;
}

export interface GeneralError {
  error: {
    detail: string;
  };
}
